export const ignoreErrApis = [
  '/parking/goodAdPull'
];

// 要忽略http 错误， 可以在接口定义config, 也可以 ignoreErrApis 添加要忽略的接口
export const isIgnoreErrApi = (error: any) => {
  if (error && error.config && error.config.ignoreError) {
    return true;
  }
  let isIgnore = false;
  const url = error.config.url || '';
  ignoreErrApis.forEach(k => {
    if (url.includes(k)) {
      isIgnore = true;
    }
  });
  return isIgnore;
};
